var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS2ElecHan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 493.0 644.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l493.0 0l0 644.0l-493.0 0l0 -644.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l493.0 0l0 644.0l-493.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m401.4972 626.0l-302.00226 0l0 0c-20.024597 0 -39.229034 -7.954712 -53.388557 -22.114258c-14.159527 -14.159546 -22.114265 -33.363953 -22.114265 -53.38855l0 -537.50507c0 -0.002084732 0.0016899109 -0.003774643 0.003774643 -0.003774643l453.0041 0.003774643l0 0c0.0020751953 0 0.0037841797 0.0016908646 0.0037841797 0.0037755966l-0.0037841797 537.5013l0 0c0 41.699036 -33.803772 75.50281 -75.50281 75.50281z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m401.4972 626.0l-302.00226 0l0 0c-20.024597 0 -39.229034 -7.954712 -53.388557 -22.114258c-14.159527 -14.159546 -22.114265 -33.363953 -22.114265 -53.38855l0 -537.50507c0 -0.002084732 0.0016899109 -0.003774643 0.003774643 -0.003774643l453.0041 0.003774643l0 0c0.0020751953 0 0.0037841797 0.0016908646 0.0037841797 0.0037755966l-0.0037841797 537.5013l0 0c0 41.699036 -33.803772 75.50281 -75.50281 75.50281z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m107.220474 347.63303l0 0c0 -11.677948 9.466835 -21.144775 21.144775 -21.144775l179.00179 0c5.6079407 0 10.986206 2.2277527 14.951599 6.1931458c3.9654236 3.9654236 6.1931763 9.343689 6.1931763 14.95163l0 84.57657c0 11.677948 -9.466827 21.144806 -21.144775 21.144806l-179.00179 0c-11.67794 0 -21.144775 -9.466858 -21.144775 -21.144806z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m107.220474 347.63303l0 0c0 -11.677948 9.466835 -21.144775 21.144775 -21.144775l179.00179 0c5.6079407 0 10.986206 2.2277527 14.951599 6.1931458c3.9654236 3.9654236 6.1931763 9.343689 6.1931763 14.95163l0 84.57657c0 11.677948 -9.466827 21.144806 -21.144775 21.144806l-179.00179 0c-11.67794 0 -21.144775 -9.466858 -21.144775 -21.144806z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m183.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m183.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m199.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m199.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m215.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m215.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m231.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m231.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m247.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m247.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m263.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m279.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m279.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m295.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m295.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m311.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m311.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m327.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m327.03412 286.8058l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m179.22047 270.26248l119.999985 1.8582458",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDasharray: "4.0,12.0",
    d: "m179.22047 270.26248l119.999985 1.8582458",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m359.0341 304.83755l0 0c0 -9.958527 8.072968 -18.031494 18.031494 -18.031494l0 0c4.782257 0 9.368622 1.8997498 12.750183 5.281311c3.3815613 3.3815613 5.281311 7.967926 5.281311 12.750183l0 0c0 9.958527 -8.072968 18.031494 -18.031494 18.031494l0 0c-9.958527 0 -18.031494 -8.072968 -18.031494 -18.031494z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m359.0341 304.83755l0 0c0 -9.958527 8.072968 -18.031494 18.031494 -18.031494l0 0c4.782257 0 9.368622 1.8997498 12.750183 5.281311c3.3815613 3.3815613 5.281311 7.967926 5.281311 12.750183l0 0c0 9.958527 -8.072968 18.031494 -18.031494 18.031494l0 0c-9.958527 0 -18.031494 -8.072968 -18.031494 -18.031494z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m414.6434 304.83755l0 0c0 -9.958527 8.072998 -18.031494 18.031494 -18.031494l0 0c4.782257 0 9.368652 1.8997498 12.750214 5.281311c3.3815613 3.3815613 5.2812805 7.967926 5.2812805 12.750183l0 0c0 9.958527 -8.072968 18.031494 -18.031494 18.031494l0 0c-9.958496 0 -18.031494 -8.072968 -18.031494 -18.031494z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m414.6434 304.83755l0 0c0 -9.958527 8.072998 -18.031494 18.031494 -18.031494l0 0c4.782257 0 9.368652 1.8997498 12.750214 5.281311c3.3815613 3.3815613 5.2812805 7.967926 5.2812805 12.750183l0 0c0 9.958527 -8.072968 18.031494 -18.031494 18.031494l0 0c-9.958496 0 -18.031494 -8.072968 -18.031494 -18.031494z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m26.501312 241.50656l445.38583 1.0393677",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m26.501312 241.50656l445.38583 1.0393677",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m27.17323 511.2861l445.38583 1.0393372",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m27.17323 511.2861l445.38583 1.0393372",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m57.178463 380.9161l0 0c0 -6.288208 5.0976105 -11.385834 11.38583 -11.385834l0 0c3.0197067 0 5.9157333 1.199585 8.050995 3.3348389c2.135254 2.135254 3.3348312 5.0312805 3.3348312 8.050995l0 0c0 6.288208 -5.0976105 11.385834 -11.385826 11.385834l0 0c-6.2882195 0 -11.38583 -5.0976257 -11.38583 -11.385834z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m57.178463 380.9161l0 0c0 -6.288208 5.0976105 -11.385834 11.38583 -11.385834l0 0c3.0197067 0 5.9157333 1.199585 8.050995 3.3348389c2.135254 2.135254 3.3348312 5.0312805 3.3348312 8.050995l0 0c0 6.288208 -5.0976105 11.385834 -11.385826 11.385834l0 0c-6.2882195 0 -11.38583 -5.0976257 -11.38583 -11.385834z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m145.0 546.4988l0 0c0 -2.4846191 2.0141754 -4.4987793 4.4987793 -4.4987793l77.04968 0c1.193161 0 2.3374329 0.47399902 3.1811218 1.317688c0.84368896 0.8436279 1.3176575 1.987915 1.3176575 3.1810913l0 17.994568c0 2.4846191 -2.0141754 4.4987793 -4.4987793 4.4987793l-77.04968 0c-2.484604 0 -4.4987793 -2.0141602 -4.4987793 -4.4987793z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m145.0 546.4988l0 0c0 -2.4846191 2.0141754 -4.4987793 4.4987793 -4.4987793l77.04968 0c1.193161 0 2.3374329 0.47399902 3.1811218 1.317688c0.84368896 0.8436279 1.3176575 1.987915 1.3176575 3.1810913l0 17.994568c0 2.4846191 -2.0141754 4.4987793 -4.4987793 4.4987793l-77.04968 0c-2.484604 0 -4.4987793 -2.0141602 -4.4987793 -4.4987793z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m103.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m103.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m119.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m119.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m135.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m135.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m151.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m151.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m167.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m167.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m183.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m183.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m199.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m199.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m215.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m215.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m231.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m231.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m247.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m247.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m263.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m279.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m279.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m295.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m295.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m311.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m311.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m327.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m327.03412 470.2651l0 22.771637",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m170.0 16.0l0 226.01575",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.0 16.0l0 226.01575",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m28.0 152.0l144.0 -1.0078735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m28.0 152.0l144.0 -1.0078735",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m215.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m215.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m231.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m231.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m247.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m247.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m263.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m279.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m279.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m295.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m295.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m311.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m311.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m327.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m327.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m343.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m343.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m359.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m359.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m375.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m375.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m391.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m391.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m407.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m407.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m423.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m423.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m439.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m439.03412 41.26509l0 22.771652",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m295.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m295.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m311.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m311.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m327.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m327.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m343.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m343.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m359.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m359.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m375.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m375.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m391.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m391.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m407.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m407.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m423.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m423.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m439.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m439.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m416.17322 149.10765l0 0c0 -1.0118256 0.82025146 -1.8320618 1.8320618 -1.8320618l19.107544 0c0.48590088 0 0.9518738 0.19302368 1.2954712 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82025146 1.8320618 -1.8320618 1.8320618l-19.107544 0c-1.0118103 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m416.17322 149.10765l0 0c0 -1.0118256 0.82025146 -1.8320618 1.8320618 -1.8320618l19.107544 0c0.48590088 0 0.9518738 0.19302368 1.2954712 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82025146 1.8320618 -1.8320618 1.8320618l-19.107544 0c-1.0118103 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m381.91077 149.10765l0 0c0 -1.0118256 0.82022095 -1.8320618 1.8320618 -1.8320618l19.107544 0c0.48587036 0 0.9518738 0.19302368 1.2954407 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82022095 1.8320618 -1.8320312 1.8320618l-19.107544 0c-1.0118408 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m381.91077 149.10765l0 0c0 -1.0118256 0.82022095 -1.8320618 1.8320618 -1.8320618l19.107544 0c0.48587036 0 0.9518738 0.19302368 1.2954407 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82022095 1.8320618 -1.8320312 1.8320618l-19.107544 0c-1.0118408 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m347.6483 149.10765l0 0c0 -1.0118256 0.82025146 -1.8320618 1.8320618 -1.8320618l19.107544 0c0.48590088 0 0.9518738 0.19302368 1.2954712 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82025146 1.8320618 -1.8320618 1.8320618l-19.107544 0c-1.0118103 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m347.6483 149.10765l0 0c0 -1.0118256 0.82025146 -1.8320618 1.8320618 -1.8320618l19.107544 0c0.48590088 0 0.9518738 0.19302368 1.2954712 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82025146 1.8320618 -1.8320618 1.8320618l-19.107544 0c-1.0118103 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m313.38583 149.10765l0 0c0 -1.0118256 0.82022095 -1.8320618 1.8320618 -1.8320618l19.107513 0c0.48590088 0 0.9519043 0.19302368 1.2954712 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82022095 1.8320618 -1.8320618 1.8320618l-19.107513 0c-1.0118408 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m313.38583 149.10765l0 0c0 -1.0118256 0.82022095 -1.8320618 1.8320618 -1.8320618l19.107513 0c0.48590088 0 0.9519043 0.19302368 1.2954712 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82022095 1.8320618 -1.8320618 1.8320618l-19.107513 0c-1.0118408 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m279.12335 149.10765l0 0c0 -1.0118256 0.82025146 -1.8320618 1.8320618 -1.8320618l19.107544 0c0.48590088 0 0.9518738 0.19302368 1.2954712 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82025146 1.8320618 -1.8320618 1.8320618l-19.107544 0c-1.0118103 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m279.12335 149.10765l0 0c0 -1.0118256 0.82025146 -1.8320618 1.8320618 -1.8320618l19.107544 0c0.48590088 0 0.9518738 0.19302368 1.2954712 0.53660583c0.3435669 0.3435669 0.5365906 0.80955505 0.5365906 1.2954559l0 7.328003c0 1.0118256 -0.82025146 1.8320618 -1.8320618 1.8320618l-19.107544 0c-1.0118103 0 -1.8320618 -0.8202362 -1.8320618 -1.8320618z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m279.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m279.03412 79.80577l0 22.77166",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m170.0 194.50919l23.496063 0l0 0c12.976517 0 23.496063 6.042389 23.496063 13.496063c0 7.4536743 -10.5195465 13.496063 -23.496063 13.496063l-23.496063 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.0 194.50919l23.496063 0l0 0c12.976517 0 23.496063 6.042389 23.496063 13.496063c0 7.4536743 -10.5195465 13.496063 -23.496063 13.496063l-23.496063 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m188.0 208.29396l0 0c0 -3.0353851 2.460678 -5.496063 5.496063 -5.496063l0 0c1.4576416 0 2.8555908 0.5790558 3.8863068 1.6097565c1.0307007 1.030716 1.6097565 2.4286652 1.6097565 3.8863068l0 0c0 3.0354004 -2.460678 5.496063 -5.496063 5.496063l0 0c-3.0353851 0 -5.496063 -2.4606628 -5.496063 -5.496063z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m188.0 208.29396l0 0c0 -3.0353851 2.460678 -5.496063 5.496063 -5.496063l0 0c1.4576416 0 2.8555908 0.5790558 3.8863068 1.6097565c1.0307007 1.030716 1.6097565 2.4286652 1.6097565 3.8863068l0 0c0 3.0354004 -2.460678 5.496063 -5.496063 5.496063l0 0c-3.0353851 0 -5.496063 -2.4606628 -5.496063 -5.496063z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6d727",
    d: "m351.2966 212.92389l42.0 -42.0l42.0 42.0l-21.0 0l0 141.08661l-42.0 0l0 -141.08661z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1e1e1e",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m351.2966 212.92389l42.0 -42.0l42.0 42.0l-21.0 0l0 141.08661l-42.0 0l0 -141.08661z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2ElecHan);
export default __webpack_public_path__ + "static/media/s2-elec-han.8b4fe71cb7badf6e03d4a807e2f710dc.svg";
export { ForwardRef as ReactComponent };